/**
 * @generated SignedSource<<28ddf68726a3abcecfaa5fd497f20ffd>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type MultiUploadInputObject = {
  uploads: ReadonlyArray<UploadInputObject>;
};
export type UploadInputObject = {
  id: string;
  metadata: UploadMetadataInputObject;
  storage: string;
};
export type UploadMetadataInputObject = {
  filename: string;
  mimeType: string;
  size: number;
};
export type accountDropzone_AccountIngestStartMutation$variables = {
  confirmUnverified?: boolean | null | undefined;
  multiUploadInput: MultiUploadInputObject;
  targetAccountNumber?: string | null | undefined;
};
export type accountDropzone_AccountIngestStartMutation$data = {
  readonly accountIngestStart: {
    readonly errors: ReadonlyArray<{
      readonly message: string;
    }>;
    readonly multiUpload: {
      readonly id: string;
      readonly phase: string | null | undefined;
    } | null | undefined;
    readonly warnings: ReadonlyArray<string>;
  } | null | undefined;
};
export type accountDropzone_AccountIngestStartMutation = {
  response: accountDropzone_AccountIngestStartMutation$data;
  variables: accountDropzone_AccountIngestStartMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "confirmUnverified"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "multiUploadInput"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "targetAccountNumber"
},
v3 = [
  {
    "kind": "Variable",
    "name": "confirmUnverified",
    "variableName": "confirmUnverified"
  },
  {
    "kind": "Variable",
    "name": "multiUploadInput",
    "variableName": "multiUploadInput"
  },
  {
    "kind": "Variable",
    "name": "targetAccountNumber",
    "variableName": "targetAccountNumber"
  }
],
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "concreteType": "MultiUpload",
  "kind": "LinkedField",
  "name": "multiUpload",
  "plural": false,
  "selections": [
    (v4/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "phase",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "message",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "warnings",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "accountDropzone_AccountIngestStartMutation",
    "selections": [
      {
        "alias": null,
        "args": (v3/*: any*/),
        "concreteType": "AccountIngestStartMutationPayload",
        "kind": "LinkedField",
        "name": "accountIngestStart",
        "plural": false,
        "selections": [
          (v5/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "UserError",
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v6/*: any*/)
            ],
            "storageKey": null
          },
          (v7/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v2/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "accountDropzone_AccountIngestStartMutation",
    "selections": [
      {
        "alias": null,
        "args": (v3/*: any*/),
        "concreteType": "AccountIngestStartMutationPayload",
        "kind": "LinkedField",
        "name": "accountIngestStart",
        "plural": false,
        "selections": [
          (v5/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "UserError",
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v6/*: any*/),
              (v4/*: any*/)
            ],
            "storageKey": null
          },
          (v7/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "14b3f28781dd5df6cb13b27630bfaed4",
    "id": null,
    "metadata": {},
    "name": "accountDropzone_AccountIngestStartMutation",
    "operationKind": "mutation",
    "text": "mutation accountDropzone_AccountIngestStartMutation(\n  $multiUploadInput: MultiUploadInputObject!\n  $targetAccountNumber: String\n  $confirmUnverified: Boolean\n) {\n  accountIngestStart(multiUploadInput: $multiUploadInput, targetAccountNumber: $targetAccountNumber, confirmUnverified: $confirmUnverified) {\n    multiUpload {\n      id\n      phase\n    }\n    errors {\n      message\n      id\n    }\n    warnings\n  }\n}\n"
  }
};
})();

(node as any).hash = "92d80623e56a97c11050df8ba8e81fd1";

export default node;
